import Request from "../handleRequest/Request";
const api = "api/admin/employee/";
const apiAvatar = "api/admin/employee/avatar/";
export default {
  list() {
    return Request.get(api, "")
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  delete(data) {
    return Request.delete(api, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  add(data) {
    return Request.post(api, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
  uploadAvatar(id, data) {
    return Request.uploadFile(apiAvatar + id, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  update(data) {
    return Request.patch(api, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
};
